<template>
  <el-autocomplete 
    v-model="inputValue"
    :placeholder="placeholder"
    :readonly="readonly"
    :disabled="disabled"
    :value-key="labelKey"
    size="small"
    :fetch-suggestions="querySearch"
    @select="handleSelect"
  />
</template>
<script>
export default {
  name: 'VAutocomplete',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => ([])
    },
    labelKey: {
      type: String,
      default: 'name'
    },
    valueKey: {
      type: String,
      default: 'id'
    }
  },
  data() {
    return {
      inputValue: this.value
    }
  },
  watch: {
    value(val) {
      if(this.inputValue !== val) {
        this.inputValue = val
      }
    },
    inputValue(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    querySearch(queryString, cb) {
      let list = this.list.slice(0) // 深拷貝數組
      let results = queryString? list.filter(item => {
        return item[this.labelKey].toLowerCase().indexOf(queryString.toLowerCase()) !== -1
      }) : list
      cb(results)
    },
    handleSelect(item) {
      this.$emit('select', item)
    }
  }
}
</script>
<style lang="scss" scoped>
.el-autocomplete {
    width: 100%;
}
</style>